import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_jobs_hiring_manager_action,
  get_loggedin_user_meta_data_action,
  get_all_added_skills_hiring_manager_action,
  get_suggested_mentors_hiring_manager_action,
  get_suggested_candidates_hiring_manager_action,
} from "../../../redux/_actions";

function useHiringManagerDashboardNew(props) {
  const [allPublishedJobs, setAllPublishedJobs] = useState();
  const [allJobsLoading, setAllJobsLoading] = useState(false);
  const [assignedMentors, setAssignedMentors] = useState();
  const [appliedMentors, setAppliedMentors] = useState();
  const [companyName, setCompanyName] = useState({});
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState();
  const [suggestedMentorsLoading, setSuggestedMentorsLoading] = useState(false);
  const [suggestedMentors, setSuggestedMentors] = useState([]);
  const [suggestedCandidatesLoading, setSuggestedCandidatesLoading] =
    useState(false);
  const [suggestedCandidates, setSuggestedCandidates] = useState([]);
  const [mentorSelectedSkill, setMentorSelectedSkill] = useState();
  const [candidateSelectedSkill, setCandidateSelectedSkill] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { jobsPostedData } = useSelector(
    (state) => state.get_jobs_hiring_manager_reducer
  );
  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );
  const { allAddedSkillsData } = useSelector(
    (state) => state.get_all_added_skills_hiring_manager_reducer
  );
  const { suggestedMentorsData } = useSelector(
    (state) => state.get_suggested_mentors_hiring_manager_reducer
  );
  const { suggestedCandidatesData } = useSelector(
    (state) => state.get_suggested_candidates_hiring_manager_reducer
  );

  useEffect(() => {
    getAllJobs();
    callSkillsApi();
  }, []);

  useEffect(() => {
    if (jobsPostedData?.data) {
      let data = jobsPostedData?.data;
      let results = data.results.filter((item) => item.status === "publish");
      setAllPublishedJobs(results);
    }
  }, [jobsPostedData]);

  useEffect(() => {
    if (jobsPostedData?.data) {
      let data = jobsPostedData?.data;
      let results = data.results.filter((item) => item.mentor_name !== null);
      setAssignedMentors(results);
    }
  }, [jobsPostedData]);

  useEffect(() => {
    if (jobsPostedData?.data) {
      let data = jobsPostedData?.data;
      let results = data.results.filter((item) => item.status === "publish");
      setAppliedMentors(results);
    }
  }, [jobsPostedData]);

  useEffect(() => {
    if (allAddedSkillsData?.data) {
      let data = allAddedSkillsData.data?.results;
      let results =
        Array.isArray(data) &&
        data.map((item) => {
          return item.skill;
        });
      if (results && results.length > 0) {
        getSuggestedMentorsApi(results);
        getSuggestedCandidatesApi(results);
      }
    }
  }, [allAddedSkillsData]);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setCompanyName(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    if (allAddedSkillsData?.data) {
      setSkillsTagsAdded(allAddedSkillsData.data?.results);
    }
  }, [allAddedSkillsData]);
  useEffect(() => {
    if (suggestedMentorsData?.data) {
      let results = suggestedMentorsData?.data;
      setSuggestedMentors(results);
    }
  }, [suggestedMentorsData]);
  useEffect(() => {
    if (suggestedCandidatesData?.data) {
      let results = suggestedCandidatesData?.data;
      setSuggestedCandidates(results);
    }
  }, [suggestedCandidatesData]);

  const getAllJobs = async () => {
    setAllJobsLoading(true);
    await dispatch(get_jobs_hiring_manager_action());
    await dispatch(get_loggedin_user_meta_data_action());
    setAllJobsLoading(false);
  };

  const callSkillsApi = async () => {
    setSkillsListLoading(true);
    await dispatch(get_all_added_skills_hiring_manager_action());
    setSkillsListLoading(false);
  };

  const getSuggestedMentorsApi = async (skills) => {
    setSuggestedMentorsLoading(true);
    await dispatch(
      get_suggested_mentors_hiring_manager_action({ skills: skills })
    );
    setSuggestedMentorsLoading(false);
  };

  const getSuggestedCandidatesApi = async (skills) => {
    setSuggestedCandidatesLoading(true);
    await dispatch(
      get_suggested_candidates_hiring_manager_action({ skills: skills })
    );
    setSuggestedCandidatesLoading(false);
  };

  const onEditJobClick = (id) => {
    if (id) {
      navigate(`/create-job/${id}`, {
        state: id,
      });
    } else navigate(`/create-job`);
  };

  const onViewJobsClick = () => {
    navigate("/hiring-manager-jobs");
  };

  const onViewJobClick = (id) => {
    navigate(`/hiring-manager-kanboard/${id}`, {
      state: id,
    });
  };

  const onViewMentorsAppliedClick = (id) => {
    navigate(`/view-mentors-applied/${id}`, {
      state: id,
    });
  };

  const onViewMentorsClick = (id) => {
    if (id)
      navigate(`/view-mentor-profile/${id}`, {
        state: { id: id, jobTitle: id.title },
      });
  };

  const getJobUpdateIndex = (job) => {
    if (job?.rejected > 0) return 6;
    else if (job?.hired > 0) return 5;
    else if (job?.offer > 0) return 4;
    else if (job?.interview > 0) return 3;
    else if (job?.assessment > 0) return 2;
    else return 1;
  };

  const onMentorJobsSkillsChange = (skill) => {
    setMentorSelectedSkill(skill);
    let data = [];
    data.push(skill.skill);
    getSuggestedMentorsApi(data);
  };

  const onCandidatesJobsSkillsChange = (skill) => {
    setCandidateSelectedSkill(skill);
    let data = [];
    data.push(skill.skill);
    getSuggestedCandidatesApi(data);
  };

  const onViewMentorProfileClick = (id) => {
    if (id) navigate(`/mentor-profile/${id}`, { state: id });
  };

  const onViewCandidateProfileClick = (id) => {
    if (id) navigate(`/view-candidate-profile/${id}`, { state: id });
  };

  const onCandidateSkillUnselectClick = () => {
    setCandidateSelectedSkill(null);
    if (allAddedSkillsData?.data) {
      let data = allAddedSkillsData.data?.results;
      let results = Array.isArray(data) && data.map((item) => {
        return item.skill;
      });
      if (results && results.length > 0) {
        getSuggestedCandidatesApi(results);
      }
    }
  };
  const onMentorSkillUnselectClick = () => {
    setMentorSelectedSkill(null);
    if (allAddedSkillsData?.data) {
      let data = allAddedSkillsData.data?.results;
      let results =
        Array.isArray(data) &&
        data.map((item) => {
          return item.skill;
        });
      if (results && results.length > 0) {
        getSuggestedMentorsApi(results);
      }
    }
  };

  const onViewAllMentorsClick = () => {
    navigate(`/all-mentors`);
  };

  const onViewAllCandidatesClick = () => {
    navigate(`/all-candidates`);
  };

  const onViewAllMentorsAppliedClick = () => {
    navigate("/all-applied-mentors");
  };

  return {
    allPublishedJobs,
    assignedMentors,
    appliedMentors,
    allJobsLoading,
    companyName,
    skillsListLoading,
    skillsTagsAdded,
    mentorSelectedSkill,
    candidateSelectedSkill,
    suggestedMentorsLoading,
    suggestedMentors,
    suggestedCandidates,
    suggestedCandidatesLoading,
    onEditJobClick,
    onViewJobsClick,
    onViewJobClick,
    onViewMentorsClick,
    onViewMentorsAppliedClick,
    getJobUpdateIndex,
    onViewMentorProfileClick,
    onMentorJobsSkillsChange,
    onCandidatesJobsSkillsChange,
    onViewCandidateProfileClick,
    onMentorSkillUnselectClick,
    onCandidateSkillUnselectClick,
    onViewAllMentorsClick,
    onViewAllCandidatesClick,
    onViewAllMentorsAppliedClick,
  };
}
export default useHiringManagerDashboardNew;
